import { render, staticRenderFns } from "./StockName.vue?vue&type=template&id=04036590&"
import script from "./StockName.vue?vue&type=script&lang=ts&"
export * from "./StockName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports